(function ($) {
    $(function () {

        AOS.init({
            offset: 50,
        });

        /*****
            Set some global variables
        *****/
        const template_url = $('#template_url').val();
        console.log(template_url);


        /*****
            iOS Viewport check
        *****/
        const isVHCheckNeeded = vhCheck();
        const hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
        if (isVHCheckNeeded && hasVHCKeckValue) {
            $('body').addClass('use-ios-offset');
        }


        /*****
            Nav toggle
        *****/
        $('.JS-navToggle').on('click', function (e) {
            e.preventDefault();
            $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
        });

        // Clicking any nav item closes the nav (anchor scroll still fires).
        $('.nav__primary a').on('click', function () {
            $('html').attr('data-nav-state', 'closed');
        });

        /*****
           HeaderScrollToggle
       *****/
        const handleScroll = function () {
            var scroll = $(window).scrollTop();
            //>=, not <=
            if (scroll >= 20) {
                //clearHeader, not clearheader - caps H
                $(".header").addClass("header--scrolled");
            } else {
                $(".header").removeClass("header--scrolled");
            }
        };

        $(window).scroll(handleScroll);
        handleScroll();

        /*****
            ScrollToggle
        *****/
        $('.JS-scrollToggle').on('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: document.getElementById('page-header').offsetHeight, behavior: 'smooth' });
        });


        /*****
            InitSlickSliders
        *****/
        $('.slick-slider').each(function () {
            $(this).slick()
        });

        // Slick collapses the raw thumb markup into a compact carousel, shrinking
        // page height. AOS already snapshotted pre-Slick (taller) offsets above,
        // so force a recompute or every data-aos section below stays hidden.
        window.AOS.refreshHard();

        $('.grid').imagesLoaded(function () {
            $('.grid').colcade({
                columns: '.grid-col',
                items: '.grid-item'
            });
        });



    });
})(jQuery);
